"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.COcomm = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var instance = null;
var COcomm = /*#__PURE__*/function () {
  function COcomm() {
    (0, _classCallCheck2["default"])(this, COcomm);
    this._remoteOrigin = '*';
    if (instance !== null) return instance;
    if (parent !== window) {
      instance = this;
      this.evt = new CustomEvent('msgFromParent', {});
      this._localOrigin = location.origin;
      window.addEventListener("message", this.receiveMsg(), true);
    } else {
      console.warn('Service "iframeComm" is unuseful if this document is open parent page of your browser');
    }
    console.warn('Set remote origin to specify allowed URI');
  }
  (0, _createClass2["default"])(COcomm, [{
    key: "_callbackReply",
    value: function _callbackReply(o) {
      parent.postMessage(o, this._remoteOrigin);
    }
  }, {
    key: "receiveMsg",
    value: function receiveMsg() {
      var self = this;
      var response = {
        status: 0,
        msg: "success",
        receivedData: null
      };
      return function (event) {
        var rcData = event.data;
        if (!rcData) {
          if (response.receivedData) {
            response.status = 1;
            response.msg = 'missing data';
            self._callbackReply(response);
          }
        } else {
          response.receivedData = rcData;
          self.evt.data = event.data;
          window.dispatchEvent(self.evt);
        }
      };
    }
  }, {
    key: "sendMsg",
    value: function sendMsg(data) {
      parent.postMessage(data, "*");
    }
  }], [{
    key: "isChildPage",
    value: function isChildPage() {
      return parent !== window;
    }
  }]);
  return COcomm;
}();
exports.COcomm = COcomm;
//# sourceMappingURL=COcomm.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/COcomm.js
// module id = 1097
// module chunks = 142